import React, { FC } from 'react';
import { SelectProps } from 'antd';
import { useHandbook, useHandbookKeys } from '~/controllers/handbook';
import Select from './Select';

const IdTypeSelect: FC<SelectProps<string>> = (props) => {
  const handbook = useHandbook();
  const handbookKeys = useHandbookKeys();
  const options = handbook.data?.handbooks
    ?.find((item) => item.key === handbookKeys.idType)
    ?.values?.filter(
      (item) =>
        item.key !== 'idType.PASSPORTNO' &&
        item.key !== 'idType.ENTITYNO' &&
        item.key !== 'idType.CRNO'
    )
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ?.map((item) => ({
      label: item.localizedValue,
      value: item.apiValue!,
      key: item.key,
    }));

  const { value } = props;

  return (
    <Select
      loading={handbook.isLoading}
      disabled={handbook.isLoading}
      options={options}
      allowClear
      {...props}
      // todo remove after backend support
      value={value?.toUpperCase()}
    />
  );
};

export default IdTypeSelect;
